"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Db = void 0;
const http_client_1 = require("./http-client");
class Db extends http_client_1.HttpClient {
    /**
* No description
*
* @tags database
* @name DeleteDataJson1
* @request POST:/db/{dbs}/deleteDataJson
* @secure
*/
    deleteDataJson1 = (dbs, data, params = {}) => this.request({
        path: `/db/${dbs}/deleteDataJson`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags database
* @name ExportDataCsv1
* @request POST:/db/{dbs}/exportDataCsv
* @secure
*/
    exportDataCsv1 = (dbs, data, params = {}) => this.request({
        path: `/db/${dbs}/exportDataCsv`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags database
* @name GetDataJson1
* @request POST:/db/{dbs}/getDataJson
* @secure
*/
    getDataJson1 = (dbs, data, params = {}) => this.request({
        path: `/db/${dbs}/getDataJson`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
    /**
* No description
*
* @tags database
* @name ModifyDataJson1
* @request POST:/db/{dbs}/modifyDataJson
* @secure
*/
    modifyDataJson1 = (dbs, data, params = {}) => this.request({
        path: `/db/${dbs}/modifyDataJson`,
        method: 'POST',
        body: data, secure: true, type: http_client_1.ContentType.Json, ...params,
    });
}
exports.Db = Db;
//# sourceMappingURL=Db.js.map